import React from "react"
import styled from "styled-components"

const StyledPreTitle = styled.h3`
    margin: 0;
    font-weight: 700;
    font-style: normal;
    font-size: 0.78rem;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: var(--muted-strong);
    text-align: left;
    opacity: 0.88;

    @media only screen and (max-width: 600px) {
        font-size: 0.74rem;
    }
`

function PreTitle ({children}) {
    return (
        <StyledPreTitle>
            {children}
        </StyledPreTitle>

    )
}

export {PreTitle}
export default PreTitle
